import { render, staticRenderFns } from "./PromotionChangeForm.vue?vue&type=template&id=4dd7913e&"
import script from "./PromotionChangeForm.vue?vue&type=script&lang=js&"
export * from "./PromotionChangeForm.vue?vue&type=script&lang=js&"
import style0 from "../scss/app.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports